import * as Apollo from '@apollo/react-hooks'
import * as React from 'react'

import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { DELETE_CREDENTIALS, logout } from 'main/util/auth'

import SupportPhoneLink from '../SupportPhoneLink'
import { ItemContainer, StyledNativeLink } from './styles'

interface IProps {
  currentOnboardingSlug: string
  isOnboarding: boolean
}

function DirectorMenu(props: IProps) {
  const { isOnboarding } = props

  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  const [deleteCredentials] = Apollo.useMutation(DELETE_CREDENTIALS, {
    onCompleted: () => handleCompleteLogout(isSSO),
  })

  return (
    <ItemContainer>
      {renderDirectorLinks()}
      <StyledNativeLink onClick={() => deleteCredentials()}>Log Out</StyledNativeLink>
      <SupportPhoneLink />
    </ItemContainer>
  )

  function renderDirectorLinks() {
    return isOnboarding ? (
      <StyledNativeLink href="/onboarding">Continue Onboarding</StyledNativeLink>
    ) : (
      <StyledNativeLink href="/admin">Program Dashboard</StyledNativeLink>
    )
  }
}

function handleCompleteLogout(isSSO: boolean) {
  logout(isSSO)
}

export default React.memo(DirectorMenu)
